import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { getIsRtl } from '../utils';

var useStyles = makeStyles(function (theme) {
  return {
    appBar: {
      background: theme.palette.grey[100],
      minWidth: 300
    },
    root: {
      alignItems: 'flex-start'
    },
    gutters: {
      padding: '8px 5%'
    },
    leftLabel: {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.grey['A700'],
      textAlign: 'left'
    },
    rightLabel: {
      color: theme.palette.grey['A700'],
      textAlign: 'left'
    },
    rtl: {
      textAlign: 'right'
    },
    fixed: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      zIndex: 0
    }
  };
});

var SisccFooter = React.forwardRef(function (_ref, ref) {
  var _cx, _cx2, _cx3;

  var leftLabel = _ref.leftLabel,
      _ref$rightLabel = _ref.rightLabel,
      rightLabel = _ref$rightLabel === undefined ? [] : _ref$rightLabel,
      isFixed = _ref.isFixed;

  var classes = useStyles();
  var theme = useTheme();
  var isRtl = getIsRtl(theme);

  return React.createElement(
    AppBar,
    {
      ref: ref,
      'data-testid': 'footer-bar-test-id',
      position: 'static',
      className: cx(classes.appBar, (_cx = {}, _cx[classes.fixed] = isFixed, _cx))
    },
    React.createElement(
      Toolbar,
      { classes: { root: classes.root, gutters: classes.gutters } },
      React.createElement(
        Grid,
        { xs: 4, item: true, container: true, justifyContent: 'flex-start', alignItems: 'flex-start' },
        React.createElement(
          Typography,
          { variant: 'body2', className: cx(classes.leftLabel, (_cx2 = {}, _cx2[classes.rtl] = isRtl, _cx2)) },
          leftLabel
        )
      ),
      React.createElement(
        Grid,
        { xs: 8, item: true, container: true, justifyContent: 'flex-end', alignItems: 'flex-start' },
        React.createElement(
          Typography,
          { variant: 'body2', className: cx(classes.rightLabel, (_cx3 = {}, _cx3[classes.rtl] = !isRtl, _cx3)) },
          rightLabel
        )
      )
    )
  );
});

SisccFooter.propTypes = process.env.NODE_ENV !== "production" ? {
  leftLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  rightLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isFixed: PropTypes.bool
} : {};

export default SisccFooter;